export class AnnotationsReaderBase {
  constructor (annotationsHelper) {
    Object.defineProperties(this, {
      _annotationsHelper: {value: annotationsHelper}
    });
  }

  capture (viewport, rectangle, zoom) {
    if (this._capture) {
      const {content, meta} = this._annotationsHelper.getSvgData(viewport, rectangle, zoom);
      return this._capture(content, meta);
    }
  }

  render (context) {}

  cleanup () {}
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/capturing/readers/AnnotationsReaderBase.js